import React, { useId } from 'react'
import PropTypes from 'prop-types'

const PlayIcon = React.forwardRef(function PlayIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M23.45 11.11L5.45 2.10999C5.14 1.94999 4.77 1.96999 4.47 2.14999C4.18 2.32999 4 2.64999 4 2.99999V21C4 21.35 4.18 21.67 4.47 21.85C4.63 21.95 4.82 22 5 22C5.15 22 5.31 21.96 5.45 21.89L23.45 12.89C23.79 12.72 24 12.38 24 12C24 11.62 23.79 11.27 23.45 11.11Z"></path>
    </svg>
  )
})

PlayIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

PlayIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default PlayIcon
